<template>
  <div class="footer">
    <!-- ---------- -->

    <div class="footer_warp">
      <div class="footer_cont">
        <!-- 上部 -->
        <div class="footer_cont_l">
          <!--上部 左 -->
          <div class="footer_cont_l_div">
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">{{ $t('footer.companyOverview') }}</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList"
                    :key="index"
                    @click="toGuid(item.url, item.id)"
                >
                  {{ $t(item.i18nKey) }}
                </li>

                <!-- <li>企业荣誉</li> -->
              </ul>
            </div>
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">{{ $t('footer.companyProducts') }}</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList2"
                    :key="index"
                    @click="toPages(item.url)"
                >
                  {{ $t(item.i18nKey) }}
                </li>
              </ul>
            </div>
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">{{ $t('footer.serviceSupport') }}</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList3"

                    :key="index"
                    @click="toNews(item.url)"
                >
                  {{ $t(item.i18nKey) }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- top 右侧 -->
        <div class="footer_cont_c">
          <div>
            <img src="@/assets/img/logo2-2.png" alt="" class="shanami-logo"/>
            <span class="ctct">
              <span class="ctct_erweima">
                <img src="@/assets/img/weixin_erweima.jpg">
              </span>
<!--              <img src="@/assets/img/weiXinLogo.png">-->
            </span>
          </div>
          <div>
            <p class="address">
              {{ $t('footer.serviceEmail') }}: <a href="mailto:shanmai@shanmai-china.com" style="color: white;"> shanmai@shanmai-china.com </a>
            </p>
            <p class="address">
              {{ $t('footer.serviceHotline') }}: <a href="tel:18001820616" style="color: white;"> 180 0182 0616 </a>
            </p>
            <p class="address" style="margin-top: 1rem">
              {{ $t('footer.address') }}<br/>
            </p>
          </div>
        </div>
      </div>
      <!-- 下部 -->
      <div class="footer_warp_btm">
        <p>
          {{ $t('footer.copyright') }}&ensp;&ensp;&ensp;{{ $t('footer.icp') }}
        </p>
      </div>
    </div>

    <!-- --------- -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      // 企业概况
      arrList: [
        {
          i18nKey: "footer.contactUs",
          url: "/contact",
          id: "briefIntroduction",
        },
      ],
      // 公司产品
      arrList2: [
        {
          i18nKey: "footer.smartDisplay",
          url: "/product/displayCase"
        },
        {
          i18nKey: "footer.accessControl",
          url: "/product/entranceGuard"
        },
        {
          i18nKey: "footer.softwarePlatform",
          url: "/product/softwarePlatform/entranceGuardSoftware"
        }

      ],
      // 服务支持
      arrList3: [
        // {
        //   title: "售后服务",
        //   url: "/aftersales"
        // },
        {
          i18nKey: "footer.solutions.accessControl",
          name: "accessControlIntelligentSystemServices",
          url: '/service/accessControlIntelligentSystemServices'
        },
        {
          i18nKey: "footer.solutions.smartDisplay",
          name: "smartDisplayCaseService",
          url: '/service/smartDisplayCaseService'
        },
        {
          i18nKey: "footer.solutions.smartLocker",
          name: "smartLockersService",
          url: '/service/smartLockersService'
        },
        {
          i18nKey: "footer.solutions.glassDoor",
          name: "glassDoorHandleSmartLockService",
          url: '/service/glassDoorHandleSmartLockService'
        },
        // {
        //   i18nKey: "footer.solutions.smartBuilding",
        //   name: "smartBuildingsService",
        //   url: '/service/smartBuildingsService'
        // }
      ]
    };
  },

  mounted() {
    let _this = this;
    _this.$nextTick(function () {
      window.addEventListener("scroll", _this.handleScroll);
    });
  },

  methods: {
    // 锚点跳转
    toGuid(path, id) {
      localStorage.setItem("toId", id);
      this.$router.push(path);
      //查找存储的锚点id
      let Id = localStorage.getItem("toId");
      let toElement = document.getElementById(Id);
      //锚点存在跳转
      if (Id) {
        toElement.scrollIntoView();
        localStorage.setItem("toId", "");
      }
    },

    toPages(url) {
      this.$router.push(url);
    },
    toNews(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style scoped lang="scss">



.footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  //height: 435px;
  //min-width: 750px;
  //background: #17213d;
  //background: #EBEBEB;
  margin-top: 15rem;
  background: black;
  padding-top: 10rem;

}

.footer_warp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  //height: 388px;
}

.footer_cont {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 100px;
}

.footer_cont_l {
  font-size: 16px;
  font-weight: 500;
  color: #dddddd;
  line-height: 22px;
  padding-top: 77px;
}

.footer_cont_l_title {
  font-size: 16px;
  font-weight: 500;
  color: #dddddd;
  line-height: 22px;
  width: 64px;
}

.footer_cont_l_ul {
  margin-top: 36px;

  li {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      color: $shanMai_green;
      text-decoration: underline $shanMai_blue;
    }
  }
}

.footer_cont_l_div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: 5rem;
}

.footer_cont_l_div_item {
  margin-right: 5.6rem;
  margin-top: 3rem;
  width: 170px;
}

.footer_cont_c {
  margin-top: 4.3rem;
  margin-left: 3.5rem;

  @media screen and (max-width: 500px){
    .shanami-logo {
      width: 9rem !important;
    }
  }
  img {
    width: 11.25rem;
    height: 100%;
  }
}

@media screen and (max-width: 500px) {
  .ctct {
    margin: 3rem 8rem 0 0 !important;
  }
}

.ctct {
  position: relative;
  float: right;
  width: 2rem;
  margin: 3rem 5.6rem 0 0;

  //&:hover {
  //  .ctct_erweima {
  //    display: block;
  //  }
  //}

  //img {
  //  width: 1.5rem;
  //}
}

.ctct_erweima {
  //display: none;
  position: absolute;
  bottom: -80px;
  left: -65px;
  width: 128px;
  //height: 128px;
  @media screen and (max-width: 430px) {
    left: -90px;
  }
  //&:after {
  //  content: "";
  //  position: absolute;
  //  top: -18px;
  //  left: 40px;
  //  display: block;
  //  //background: white;
  //  border: 10px solid transparent;
  //  border-bottom: 10px solid white;
  //}

  img {
    width: 8rem;
    height: 8rem;
  }
}

@media screen and (max-width: 500px) {
  .address {
    font-size: 0.8rem !important;
  }
}

.address {
  width: 467px;
  font-size: 16px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  &:nth-child(1) {
    margin-top: 42px;
  }
}

.footer_cont_r {
  margin-top: 79px;
  margin-left: 70px;

  p {
    text-align: center;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    margin-top: 17px;
  }
}

.footer_cont_r_border {
  width: 111px;
  //height: 109px;
  border: 1px solid #979797;

  img {
    width: 95px;
    height: 95px;
    margin: 7px 8px;
  }
}

.footer_warp_btm {
  width: 100%;
  //height: 65px;
  margin-top: 65px;
  border-top: 1px solid #444444;

  p {
    font-size: 12px;
    font-weight: 400;
    color: #a3a3a3;
    line-height: 48px;
    text-align: center;
  }
}

</style>
